import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    LoadCrossSells,
    LoadCustomersAlsoPurchased,
    LoadFeaturedCategory,
    LoadProducts,
    LoadRecentlyViewed,
    LoadRecommendedProducts,
    LoadRelatedProducts,
    LoadTopSellers,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import { utilsRandom } from "@waytek/Utilities/global/utils";

interface Parameter {
    carouselId: string;
    carouselType: string;
    relatedProductType: string;
    seedWithManuallyAssigned: string;
    displayProductsFrom: string;
    selectedCategoryIds: string[];
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    isShellEdit?: boolean;
    widgetPosition?: number;

    selectedProductIds: string[];
}

interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
}

type HandlerType = Handler<Parameter, Props>;

export const LoadNewProducts: HandlerType = props => {
    const {
        parameter: {
            carouselType,
            numberOfProductsToDisplay,
            displayProductsFrom,
            selectedCategoryIds,
            selectedProductIds,
        },
    } = props;

    if (carouselType !== "newProducts") {
        return;
    }

    if (displayProductsFrom === "random") {
        const categoryId = selectedCategoryIds[0] || null;

        if (!categoryId) {
            return;
        }

        props.getProductCollectionParameter = {
            filter: "newProducts" as any,
            categoryId,
            pageSize: numberOfProductsToDisplay,
            expand: ["properties"],
            additionalQueryStringParameters: [utilsRandom()],
        };
    }

    if (displayProductsFrom === "custom") {
        const productIds = selectedProductIds;

        if (!productIds || productIds.length === 0) {
            return;
        }

        props.getProductCollectionParameter = {
            productIds,
            expand: ["properties"],
            additionalQueryStringParameters: [utilsRandom()],
        };
    }
};

export const chain = [
    LoadNewProducts,
    LoadRecentlyViewed,
    LoadCrossSells,
    LoadRelatedProducts,
    LoadCustomersAlsoPurchased,
    LoadTopSellers,
    LoadFeaturedCategory,
    LoadRecommendedProducts,
    LoadProducts,
];

const loadCarouselProducts = createHandlerChainRunner(chain, "LoadCarouselProducts");
export default loadCarouselProducts;
